import { OverflowMenu } from 'ui/actionMenu';
import { AllowedActionMenuElements, ActionMenuOption } from 'ui/actionMenu/types';
import { useModalContext } from 'utils/contexts/modal';
import type { AllSendersModalState, AuthedEmailsTableActionButtonProps } from '../types';

export const AuthedEmailsTableActionButton = ({
  authedEmail,
}: AuthedEmailsTableActionButtonProps) => {
  const editId = 'edit-sender';
  const deleteId = 'delete-sender';

  const { showModal } = useModalContext<AllSendersModalState>();

  const options: ActionMenuOption[] = [
    {
      as: AllowedActionMenuElements.Button,
      content: (
        <>
          <span>Edit</span>
        </>
      ),
      id: editId,
      onClick: () => showModal({ action: 'authedEmailEditModal', authedEmail }),
    },
    {
      as: AllowedActionMenuElements.Button,
      content: (
        <>
          <span>Delete</span>
        </>
      ),
      id: deleteId,
      onClick: () => showModal({ action: 'authedEmailDeleteModal', authedEmail }),
    },
  ];

  return (
    <OverflowMenu
      data-row={`authed-emails-table-row-${authedEmail.email}`}
      data-test="authed-emails-table-actions-button"
      id="authed-emails-table-overflow-menu"
      options={options}
    />
  );
};
